import axios from 'axios';
import api from './UserReq';

export default axios.create({
    baseURL: `${api.defaults.baseURL}user/`
});